type ConfirmIconProps = {
    width?: number;
    height?: number;
    className?: string;
};

const ConfirmIcon = ({ width = 12, height = 12, className }: ConfirmIconProps) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden
    >
        <path
            d="M2.5 6.5L5 9L9.5 3.5"
            stroke="currentColor"
            strokeWidth="1.25"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default ConfirmIcon;
